module.exports = "#define GLSLIFY 1\n#ifdef USE_DISPLACEMENTMAP\n\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, uv ).x * displacementScale + displacementBias );\n\n#endif\n"


//////////////////
// WEBPACK FOOTER
// ./src/vendor/three/renderers/shaders/ShaderChunk/displacementmap_vertex.glsl
// module id = 227
// module chunks = 0